import { configure } from "@borealis/image/client";
import { hydrate as borealisHydrate } from "@borealis/react/client";
import type { ReactNode } from "react";

const applicationName = "recommerce-explore";
configure(applicationName);

export async function hydrate<T = unknown>(id: string, render: (props: T) => ReactNode) {
	await borealisHydrate({
		id,
		i18nLoadAndActivate: (locale) => import(`../../locales/${locale}.po`),
		render,
	});
}
